import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// 🔥 REMOVE EMERGENT BADGE
setInterval(() => {
  const els = document.querySelectorAll(
    '[class*="emergent"], [id*="emergent"], a[href*="emergent"]'
  );
  els.forEach(el => el.remove());
}, 1000);